module.exports = __webpack_public_path__ + "img/user.c73ccd32.svg";